import { createSelector } from 'reselect';
import { DateTime } from 'luxon';
import * as entitlementsSelectors from 'data/entitlements/entitlementsSelectors';
import { isSanitized } from 'data/app/selectors';

import { REDUCER_KEY } from './types';

export const getAuthSession = (state) => state[REDUCER_KEY];
export const getError = (state) => state[REDUCER_KEY].error;

export const isAuthTokenValid = (state) => {
  const sanitized = isSanitized(state);
  const authSession = getAuthSession(state);
  const now = DateTime.local();
  return Boolean(sanitized || (authSession.accessToken && (!authSession.accessTokenExpired || DateTime.fromISO(authSession.accessTokenExpired) > now))
    || (authSession.refreshToken && (!authSession.refreshTokenExpired || DateTime.fromISO(authSession.refreshTokenExpired) > now)));
}

export const isAuthenticated = (state) => {
  const entitlement = entitlementsSelectors.getTopTierEntitlement(state);
  return entitlement && isAuthTokenValid(state);
};

export const getDatasetId = createSelector(
  getAuthSession,
  (authSession) => authSession.datasetId
);

export const isAuthenticatedWithDataSetId = (state) => Boolean(isAuthenticated(state) && getDatasetId(state));
